import { ReactNode } from 'react';
import { joinProductCodes } from '@paradigm/features/src/unified-rfqs/utils/productCodes';

interface Props {
  /** Strategy (non-hedge) product codes — see `strategyProductCodes`. */
  readonly productCodes: readonly string[];
  readonly children: ReactNode;
}

/**
 * Product column cell. A multi-product package is labelled by name
 * ("ETH Future + BTC Option - PRDX"), so the raw codes stay reachable
 * as a tooltip: they are what the product filters and the API speak.
 */
export default function ProductLabel({ productCodes, children }: Props) {
  return (
    <span
      title={
        productCodes.length > 1 ? joinProductCodes(productCodes) : undefined
      }
    >
      {children}
    </span>
  );
}
